import _ from 'underscore';
import { STEP_PATHS } from './step-paths';

export const defaultState = {
  tagContext: {},
  GTMContext: {
    IsGTMCloningChecked: true,
    AllowTagCloning: true,
  },
  currentStep: STEP_PATHS.uetTag.id,
  steps: [],
  loggingSteps: [],
};

export const WIZARD_ACTIONS = {
  WIZARD_NAVIGATE_NEXT: 'WIZARD_NAVIGATE_NEXT',
  WIZARD_NAVIGATE_BACK: 'WIZARD_NAVIGATE_BACK',
  SAVE_TAG_AND_NEXT: 'SAVE_TAG_AND_NEXT',
  SELECT_TAG_SETUP_METHOD: 'SELECT_TAG_SETUP_METHOD',
  GO_TO_EMAIL_DEVELOPER_STEP: 'GO_TO_EMAIL_DEVELOPER_STEP',
  NAVIGATE_WITH_PLATFORM: 'NAVIGATE_WITH_PLATFORM',
  WIZARD_UPDATE_GTM_SESSION_CONTEXT: 'WIZARD_UPDATE_GTM_SESSION_CONTEXT',
};

const basicSteps = [
  STEP_PATHS.uetTag.id,
  STEP_PATHS.tagSetup.noTag.selectTagMethod.id,
  STEP_PATHS.endFlow.id,
];

function goToNextStep(state, currentStep) {
  const rootStep = currentStep.split('.').shift();
  const currentStepIndex = _.findIndex(basicSteps, step => step.split('.').shift() === rootStep);

  return {
    ...state,
    currentStep: basicSteps[currentStepIndex + 1],
    steps: [...state.steps, currentStep],
    loggingSteps: [...state.steps, currentStep],
  };
}

function goToPreviousStep(state) {
  return {
    ...state,
    steps: state.steps.slice(0, -1),
    currentStep: state.steps[state.steps.length - 1],
    loggingSteps: [...state.steps, state.currentStep],
  };
}

function goToStep(state, currentStep, nextStep) {
  return {
    ...state,
    currentStep: nextStep,
    steps: [...state.steps, currentStep],
    loggingSteps: [...state.steps, currentStep],
  };
}

export const uetSetupWizardReducer = (state, action) => {
  switch (action.type) {
    case WIZARD_ACTIONS.WIZARD_NAVIGATE_NEXT:
      return goToNextStep({ ...state, ...action.data }, state.currentStep);
    case WIZARD_ACTIONS.WIZARD_NAVIGATE_BACK:
      return goToPreviousStep(state);
    case (WIZARD_ACTIONS.SAVE_TAG_AND_NEXT): {
      const updatedState = {
        ...state,
        tagContext: { ...action.data },
        isSaveDone: true,
      };
      return goToNextStep(updatedState, state.currentStep);
    }
    case WIZARD_ACTIONS.SELECT_TAG_SETUP_METHOD:
      return goToStep({
        ...state,
        ...action.data,
      }, state.currentStep, STEP_PATHS.tagSetup.noTag[action.data.selectedTagSetupMethod].id);
    case WIZARD_ACTIONS.GO_TO_EMAIL_DEVELOPER_STEP:
      return goToStep(state, state.currentStep, STEP_PATHS.tagSetup.noTag.emailTag.id);
    case WIZARD_ACTIONS.NAVIGATE_WITH_PLATFORM:
      return goToStep({
        ...state,
        ...action.data,
      }, state.currentStep, STEP_PATHS.tagSetup.noTag.platformTagInstructions.id);
    case WIZARD_ACTIONS.WIZARD_UPDATE_GTM_SESSION_CONTEXT: {
      return {
        ...state,
        GTMContext: { ...action.GTMContext },
      };
    }
    default:
      throw new Error('invalid goal creation wizard action');
  }
};
